<template>
  <div>
    <div class="mb-2 mx-1 font-16 fw-700">Gửi danh thiếp</div>
    <el-input
      class="ps-1 mb-2"
      size="small"
      @input="searchKeyChanged"
      v-model="searchKey"
      placeholder="Tìm tài khoản">
      <IconV2
        slot="prefix"
        class="my-2 ms-2"
        name="v2-search" />
    </el-input>
    <div
      class="d-flex px-1 flex-column overflow-auto scrollbar"
      style="height: 350px">
      <div
        v-for="item in getContactView()"
        :key="item.id">
        <div class="d-flex py-2 align-items-center">
          <el-checkbox
            v-model="item.isCheck"
            @change="selectItem(item)" />
          <div
            @click="clickItem(item)"
            class="d-flex align-items-center pointer">
            <el-avatar
              :size="40"
              :src="item.avatar"
              class="mx-12" />
            <div class="font-14 d-flex flex-column">
              <span class="trim-text-1-line fw-700" style="max-width: 170px">{{ item.displayName }}</span>
              <span class="fw-400 text-grey600">{{ item.phoneNumber }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="divider-custom" />
    <el-button
      v-if="isShowListFriend()"
      type="primary"
      size="small"
      class="float-end"
      style="margin-top: 12px"
      @click="sendEventBusinessCard">
      Gửi danh thiếp
    </el-button>
  </div>
</template>

<script>
export default {
  name: "BusinessCard",
  props: {
    conversation: {
      type: Object,
    },
  },
  data() {
    return {
      contacts: [],
      friendIds: [],
      searchKey: "",
    };
  },

  methods: {
    getContactView() {
      if (this.searchKey.trim().length === 0) {
        return this.contacts;
      } else {
        return this.contacts.filter((s) => s.displayName.toLowerCase().includes(this.searchKey.toLowerCase()));
      }
    },
    searchKeyChanged() {
      this.getContactView();
    },
    sendEventBusinessCard() {
      this.contacts.forEach((s) => (s.isCheck = false));
      this.$emit("sendBusinessCard", this.friendIds);
      this.friendIds = [];
    },
    selectItem(item) {
      if (item.isCheck) this.friendIds.push(this.contacts.find((s) => s.id === item.id).id);
      else this.friendIds.splice(this.contacts.indexOf(item.id), 1);
    },
    clickItem(item) {
      item.isCheck = !item.isCheck;
      if (item.isCheck) this.friendIds.push(this.contacts.find((s) => s.id === item.id).id);
      else this.friendIds.splice(this.contacts.indexOf(item.id), 1);
    },
    getContacts() {
      this.$http
        .get("/api/contact/filter", {
          params: {
            searchKey: "",
            accountId: this.conversation.accountId,
            page: 0,
            pageSize: 10000,
          },
        })
        .then((resp) => {
          resp.data.content.forEach((s) => (s.isCheck = false));
          this.contacts = resp.data.content;
        });
    },
  },
  created() {
    this.getContacts();
  },
};
</script>

<style scoped>
</style>